var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{staticClass:"tournament-background",attrs:{"height":"200","src":"https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Kayle_0.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }